import React from 'react';
import { useTranslation } from 'react-i18next';
import { InferType } from 'prop-types';
import { Cookie as CookieCompliancePopup } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';


const Cookie: React.FC<InferType<typeof CookieCompliancePopup.propTypes>> = (props) => {
  const { t } = useTranslation();

  const choises = ['necessary', 'marketing', 'preferences', 'statistics'].map((level) => ({
    value: level,
    label: t(`cookie.choices.${level}.label`),
    description: t(`cookie.choices.${level}.description`),
    disabled: level === 'necessary',
  }));

  return (
    <CookieCompliancePopup
      agreeText={t('cookie.agree')}
      manualText={t('cookie.manual')}
      onDisagree={() => {}}
      cookieLevels={choises}
      {...props}
    >
      <h4>{t('cookie.title')}</h4>
      <p>{t('cookie.text')}</p>
    </CookieCompliancePopup>
  );
};

export default Cookie;
